var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoweredByCpx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150.078 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #686868;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "powered_by_IX",
    "data-name": "powered by IX",
    transform: "translate(-122.801 -327.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(136.203 332.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    className: "cls-1",
    d: "M166.3,361.5a3.714,3.714,0,0,0-2.208-.828,2.937,2.937,0,1,0,.079,5.874,3.27,3.27,0,0,0,2.129-.828V369.3a6.65,6.65,0,0,1-3,.67,6.312,6.312,0,0,1-6.5-6.268,6.412,6.412,0,0,1,6.7-6.5,5.682,5.682,0,0,1,2.8.71Z",
    transform: "translate(-156.8 -350.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    className: "cls-1",
    d: "M197.728,363.586c0,4.061-3.351,6.386-7.214,6.386-3.824,0-7.214-2.286-7.214-6.386s3.351-6.386,7.214-6.386C194.338,357.2,197.728,359.526,197.728,363.586Zm-9.974,0a2.72,2.72,0,0,0,5.44,0,2.72,2.72,0,0,0-5.44,0Z",
    transform: "translate(-172.853 -350.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    className: "cls-1",
    d: "M226.858,359.092h.039a4.777,4.777,0,0,1,7.884.394,4.594,4.594,0,0,1,4.06-2.286c3.035,0,4.1,1.971,4.1,4.731v7.648h-4.258v-5.716c0-1.222.039-3.272-1.735-3.272-1.971,0-2.05,1.853-2.05,3.272v5.716h-4.258v-5.716c0-1.34,0-3.351-1.892-3.351s-1.892,2.05-1.892,3.351v5.716H222.6V357.594h4.258Z",
    transform: "translate(-196.66 -350.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    className: "cls-1",
    d: "M283.118,358.935h.039a4.274,4.274,0,0,1,3.627-1.735,6.179,6.179,0,0,1,6.071,6.426,6.049,6.049,0,0,1-5.992,6.347,4.826,4.826,0,0,1-3.706-1.537v7.135H278.9V357.594h4.258v1.34ZM283,363.586a2.72,2.72,0,0,0,5.44,0,2.72,2.72,0,1,0-5.44,0Z",
    transform: "translate(-230.766 -350.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    className: "cls-1",
    d: "M321.658,358.2v6.386c0,1.537.355,2.6,2.129,2.6,1.735,0,2.129-1.064,2.129-2.6V358.2h4.258v7.214c0,3.942-2.8,5.164-6.386,5.164s-6.386-1.222-6.386-5.164V358.2Z",
    transform: "translate(-254.088 -351.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    className: "cls-1",
    d: "M358.7,359.132h.039a4.114,4.114,0,0,1,3.824-1.932c3.233,0,4.494,2.05,4.494,4.967v7.411H362.8v-5.834c0-1.143.2-3.154-1.932-3.154-1.735,0-2.208,1.3-2.208,2.8v6.229H354.4V357.634h4.258v1.5Z",
    transform: "translate(-276.502 -350.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    className: "cls-1",
    d: "M403.467,364.3h-8.949a2.4,2.4,0,0,0,2.681,2.681,2.177,2.177,0,0,0,2.05-1.1h4.1c-.67,2.838-3.351,4.1-6.11,4.1-3.982,0-6.938-2.247-6.938-6.386,0-3.982,2.72-6.386,6.623-6.386,4.179,0,6.583,2.562,6.583,6.662v.434Zm-3.942-2.444a2.382,2.382,0,0,0-2.4-1.892,2.407,2.407,0,0,0-2.523,1.892Z",
    transform: "translate(-298.25 -350.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    className: "cls-1",
    d: "M430.1,364.672H425.88V356.2H424.5v-3.509h1.38V349.1h4.258v3.587h2.4V356.2h-2.4v8.476Z",
    transform: "translate(-318.968 -345.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    className: "cls-1",
    d: "M452.231,342.865a2.365,2.365,0,1,1-2.365-2.365A2.372,2.372,0,0,1,452.231,342.865Zm-.276,16.6H447.7V347.478h4.258Z",
    transform: "translate(-332.901 -340.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    className: "cls-1",
    d: "M460.6,358.2H466l2.168,2.484,2.168-2.484h5.479l-4.967,5.48,5.992,6.5h-5.6l-3.075-3.548-3.075,3.548h-5.6l5.992-6.5Z",
    transform: "translate(-340.17 -351.222)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(122.8 327.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    className: "cls-1",
    d: "M126.111,339.664a1.853,1.853,0,0,1-1.5-.788l-.079-.118-.355,3H122.8l.907-7.135h1.34l-.079.631.039-.039a2,2,0,0,1,1.5-.71,1.833,1.833,0,0,1,1.419.631,2.54,2.54,0,0,1,.552,1.656,3.294,3.294,0,0,1-.631,2.089A2.374,2.374,0,0,1,126.111,339.664Zm0-4.021a1.281,1.281,0,0,0-.946.394,1.564,1.564,0,0,0-.473,1.025,1.425,1.425,0,0,0,.237.986.893.893,0,0,0,.749.434,1.327,1.327,0,0,0,1.025-.473,1.684,1.684,0,0,0,.394-1.143,1.21,1.21,0,0,0-.276-.867A.9.9,0,0,0,126.111,335.643Z",
    transform: "translate(-122.8 -331.819)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    className: "cls-1",
    d: "M141.344,339.664a2.541,2.541,0,0,1-1.774-.67,2.116,2.116,0,0,1-.67-1.656,2.892,2.892,0,0,1,.788-2.05,2.732,2.732,0,0,1,2.05-.788,2.259,2.259,0,0,1,1.735.71,2.376,2.376,0,0,1,.67,1.774,2.7,2.7,0,0,1-.788,1.971A3.037,3.037,0,0,1,141.344,339.664Zm.079-1.3a1.347,1.347,0,0,0,1.38-1.38,1.129,1.129,0,0,0-.315-.867.992.992,0,0,0-.788-.355,1.343,1.343,0,0,0-.986.434,1.427,1.427,0,0,0-.394,1.064,1.272,1.272,0,0,0,.315.828A1.074,1.074,0,0,0,141.423,338.363Z",
    transform: "translate(-132.553 -331.819)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    className: "cls-1",
    d: "M154.864,339.649l-1.064-4.81h1.5l.552,2.878c0,.118.039.2.039.276v.2h0a.428.428,0,0,1,.039-.2,1.431,1.431,0,0,1,.118-.276l1.1-2.878h1.419l.394,2.838c0,.118.039.2.039.276v.2h0a1.706,1.706,0,0,0,.039-.2,1.926,1.926,0,0,0,.118-.276l1.261-2.878H162l-2.286,4.81h-1.419l-.512-3.036c0-.118-.039-.2-.039-.276v-.2a1.707,1.707,0,0,0-.039.2,1.924,1.924,0,0,0-.118.276l-1.262,3.036h-1.459Z",
    transform: "translate(-141.579 -332.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    className: "cls-1",
    d: "M178,339.664a2.669,2.669,0,0,1-1.853-.67,2.289,2.289,0,0,1-.749-1.735,2.7,2.7,0,0,1,.788-1.971,2.891,2.891,0,0,1,2.05-.788,2.082,2.082,0,0,1,1.577.67,2.524,2.524,0,0,1,.631,1.735,1.919,1.919,0,0,1-.039.473H176.78v.079a1.036,1.036,0,0,0,.315.788,1.21,1.21,0,0,0,.867.276,1.027,1.027,0,0,0,.591-.158,1.685,1.685,0,0,0,.552-.513l.907.788a3.345,3.345,0,0,1-.907.788A2.519,2.519,0,0,1,178,339.664Zm.2-4.179a1.323,1.323,0,0,0-1.1.473,1.177,1.177,0,0,0-.237.552h2.286a1.884,1.884,0,0,0-.237-.71.987.987,0,0,0-.71-.315Z",
    transform: "translate(-154.664 -331.819)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    className: "cls-1",
    d: "M190.652,334.618h1.419l-.079.788.2-.237a1.736,1.736,0,0,1,1.38-.67.77.77,0,0,1,.315.039l-.276,1.5a1.118,1.118,0,0,0-.513-.158,1.227,1.227,0,0,0-.867.315,1.515,1.515,0,0,0-.434.907l-.315,2.365H190.1Z",
    transform: "translate(-163.569 -331.819)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    className: "cls-1",
    d: "M202.6,339.664a2.669,2.669,0,0,1-1.853-.67A2.289,2.289,0,0,1,200,337.26a2.7,2.7,0,0,1,.788-1.971,2.891,2.891,0,0,1,2.05-.788,2.082,2.082,0,0,1,1.577.67,2.524,2.524,0,0,1,.631,1.735,1.919,1.919,0,0,1-.039.473H201.38v.079a1.036,1.036,0,0,0,.315.788,1.21,1.21,0,0,0,.867.276,1.027,1.027,0,0,0,.591-.158,1.685,1.685,0,0,0,.552-.513l.907.788a3.344,3.344,0,0,1-.907.788A2.4,2.4,0,0,1,202.6,339.664Zm.2-4.179a1.323,1.323,0,0,0-1.1.473,1.177,1.177,0,0,0-.237.552h2.286a1.884,1.884,0,0,0-.237-.71.866.866,0,0,0-.71-.315Z",
    transform: "translate(-169.566 -331.819)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    className: "cls-1",
    d: "M216.571,335.606a1.816,1.816,0,0,1-1.419-.591,2.223,2.223,0,0,1-.552-1.537,3.549,3.549,0,0,1,.67-2.168,2.057,2.057,0,0,1,1.656-.867,1.853,1.853,0,0,1,1.5.788l.079.118.434-3.548h1.38l-.946,7.648h-1.34l.079-.591-.039.039A2,2,0,0,1,216.571,335.606Zm.788-4.021a1.327,1.327,0,0,0-1.025.473,1.756,1.756,0,0,0-.394,1.222,1.111,1.111,0,0,0,.276.828.856.856,0,0,0,.71.315,1.281,1.281,0,0,0,.946-.394,1.564,1.564,0,0,0,.473-1.025,1.425,1.425,0,0,0-.237-.986A.946.946,0,0,0,217.36,331.585Z",
    transform: "translate(-178.411 -327.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    className: "cls-1",
    d: "M240.335,335.545a1.853,1.853,0,0,1-1.5-.788l-.079-.118-.079.71H237.3l.946-7.648h1.38l-.434,3.351a1.879,1.879,0,0,1,1.459-.67,1.833,1.833,0,0,1,1.419.631,2.54,2.54,0,0,1,.552,1.656,3.294,3.294,0,0,1-.631,2.089A2.211,2.211,0,0,1,240.335,335.545Zm-.039-4.021a1.281,1.281,0,0,0-.946.394,1.564,1.564,0,0,0-.473,1.025,1.424,1.424,0,0,0,.237.986.893.893,0,0,0,.749.434,1.327,1.327,0,0,0,1.025-.473,1.684,1.684,0,0,0,.394-1.143,1.21,1.21,0,0,0-.276-.867A.9.9,0,0,0,240.3,331.524Z",
    transform: "translate(-192.162 -327.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    className: "cls-1",
    d: "M253.559,342.133H252.1l1.261-2.681L252.1,334.8h1.5l.552,2.365a1.152,1.152,0,0,1,.079.355v.276h0a1,1,0,0,1,.079-.276,1.4,1.4,0,0,1,.158-.355l1.1-2.326h1.616Z",
    transform: "translate(-201.127 -332.001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoweredByCpx);
export default __webpack_public_path__ + "static/media/poweredByCpx.d41c05d061d8a6aa775337d66d60e449.svg";
export { ForwardRef as ReactComponent };